<template>
  <div class="text-center card-head">
    <h2 class="p-1">{{ summary.name }}</h2>
  </div>
  <div class="table-responsive">
    <table class="table table-sm table-striped">
      <thead>
        <tr>
          <th class="text-start">Particulars</th>
          <th class="text-end">Today</th>
          <th class="text-end">Last Day</th>
          <th class="text-end">This Month</th>
          <th class="text-end">This Year</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(list, index) in summary.data" :key="index">
          <tr>
            <td class="text-start">{{ list.name }}</td>
            <td class="text-end">{{ onlyCommaFormat(list.today) }} </td>
            <td class="text-end">{{ onlyCommaFormat(list.yesterday) }}</td>
            <td class="text-end">{{ onlyCommaFormat(list.this_month) }}</td>
            <td class="text-end">{{ onlyCommaFormat(list.this_year) }}</td>
          </tr>
          <tr v-if="index === 3 && summary.type == 'billing'">
            <td colspan="5">
              <hr class="m-0 border-dark border-1">
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import figureFormatter from "@/services/utils/figureFormatter";

const { onlyCommaFormat } = figureFormatter()

const props = defineProps({
  summary: Object
})
</script>
